module.exports = __webpack_public_path__ + "static/media/logo-mini.591fb053.png";